<template>
  <navbar>
    <a href="/" class="d-none d-lg-block">
      <img style="width: 67%; margin-top:-0.3em; padding-left: 20px;" src="/images/apply-logo.jpg">
    </a>
    <span class="d-none d-lg-block">
      <b-button-group class="d-flex external_sys_links" size="sm">
        <b-button variant="outline-primary" href="https://applyit.atlassian.net/jira/dashboards/last-visited">
          <img class="mx-1" src="@/assets/jira_logo.png" />
        </b-button>
        <b-button variant="outline-warning" href="https://gitlab.com/applyitlv">
          <img class="mx-1" src="@/assets/gitlab_logo.png" />
        </b-button>
        <b-button variant="outline-danger" href="https://applyit.slack.com">
          <img class="mx-1" src="@/assets/slack_logo.png" />
        </b-button>
        <b-button variant="outline-info" href="https://wiki.applyit.lv/">
          <img class="mx-1" src="@/assets/wikijs_logo.png" />
        </b-button>
      </b-button-group>
    </span>
    <button class="ml-2 d-block d-lg-none" type="button" @click="$emit('toggleSidebar', $event)">&#9776;</button>
    <b-navbar-nav class="d-none d-lg-block project-select">
      <treeselect v-if="projects_info.length > 0 && this.project_leads.length > 0" :cacheOptions="false"
        :disable-branch-nodes="true" :load-options="loadProjectOptions" v-model="curProject" :async="true"
        :open-on-click="true" :defaultOptions="true" :clearable="true" :searchable="true" :close-on-select="true"
        :clear-on-select="true">
        <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="[labelClassName, {
          'disabled-treeselect-label-cust': node.raw.isLocked,
          'softlocked-treeselect-label-cust': node.raw.isSoftLocked
        }]"
          @mousedown="if (node.raw.isLocked) { console.log('asd'); $event.stopPropagation(); $event.preventDefault(); }">
          <!-- {{ node.isBranch ? 'Branch' : 'Leaf' }} -->
          <b-badge v-if="node && !node.isBranch">{{ projects[node.id].key }}</b-badge> {{ node.label }}
          <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
        </label>
      </treeselect>
    </b-navbar-nav>
    <!--
    <b-navbar-nav>
      <b-nav-item v-if="selectedProject.id > 0" class="nav-item px-1">
        <router-link :to="projectPlanningUrl" class="nav-link" exact><i style="font-size: 13px;"
            class="nav-link"></i>Planned</router-link>
      </b-nav-item>
      <b-nav-item v-if="selectedProject.id > 0" class="nav-item px-1">
        <router-link :to="projectGraphicsUrl" class="nav-link" exact><i style="font-size: 13px;"
            class="nav-link"></i>Graphics</router-link>
      </b-nav-item>
      <b-nav-item v-if="selectedProject.id > 0" class="nav-item px-1">
        <router-link :to="projectInvoicesPaymentsUrl" class="nav-link" exact><i style="font-size: 13px;"
            class="nav-link"></i>Invoices/Payments</router-link>
      </b-nav-item>
    </b-navbar-nav> -->
    <b-navbar-nav class="ml-auto mr-1">
      <b-nav-item-dropdown right class="navbar-nav">
        <template v-slot:button-content>
          {{ user ? user.name : 'unknown' }}
        </template>
        <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
        <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </navbar>
</template>
<script>

import { dropdown } from 'vue-strap';
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import Autocomplete from 'v-autocomplete';
import Treeselect, { ASYNC_SEARCH, LOAD_ROOT_OPTIONS, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
// import { get } from 'http';
// import { set } from 'vue/types/umd';
import Vue from 'vue';
import { VT } from '@/store/types';
import navbar from './Navbar';
import ProjectsAutocompleteDropdownItem from '../views/components/documents/ProjectsAutocompleteDropdownItem.vue';

export default {
  name: 'Header',
  emits: ['toggleSidebar'],
  components: {
    navbar,
    dropdown,
    Autocomplete,
    Treeselect
  },
  data: function () {
    return {
      curProject: null,
      item: null,
      items: [],
      selectedProjectLead: {
        project_lead_id: '',
        displayName: 'Project leads'
      },
      template: ProjectsAutocompleteDropdownItem,
      projectPlanningUrl: '/jira/project-tab-planning/',
      projectGraphicsUrl: '/jira/project-tab-graphics/',
      projectInvoicesPaymentsUrl: '/jira/project-tab-invoices-payments/',
      selectedProject: {
        id: 0
      },
      projectPlanningRoutes: [
        'ProjectTabPlanning',
        'ProjectTabGraphics',
        'ProjectTabInvoicesPayments'
      ]
    };
  },
  computed: {
    ...mapGetters('Auth', [
      'permissionsMap',
      'user',
    ]),
    ...mapGetters('JiraProjects', ['sortedProjects', 'projects', 'nonArhivedProjects', 'projectLeads']),
    ...mapState('Auth', ['projects_info', 'project_leads']),
  },
  watch: {
    curProject(v) {
      Vue.nextTick(() => {
        this.projectSelected(v);
        this.curProject = undefined;
      });
    },
    item: function (val) {
      if (val) {
        this.projectPlanningUrl = `/jira/project-tab-planning/${this.item.id}`;
        this.projectGraphicsUrl = `/jira/project-tab-graphics/${this.item.id}`;
        this.projectInvoicesPaymentsUrl = `/jira/project-tab-invoices-payments/${this.item.id}`;
        this.selectedProject.id = this.item.id;
        let sameRoute = false;
        for (let i = 0; i < this.projectPlanningRoutes.length; i++) {
          if (this.$route.name == this.projectPlanningRoutes[i]) {
            sameRoute = true;
            this.$router.push({ name: this.projectPlanningRoutes[i], params: { id: this.item.id } }).catch(() => { /* investigate why this navigation is needed */ });
          }
        }
        if (!sameRoute) {
          this.$router.push({ name: 'ProjectTabPlanning', params: { id: this.item.id } }).catch(() => { /* investigate why this navigation is needed */ });
        }
      }
    },
    nonArhivedProjects: function () {
      this.items = this.sortedProjects;
      if (this.$route.params.id) {
        for (let i = 0; i < this.projectPlanningRoutes.length; i++) {
          if (this.$route.name == this.projectPlanningRoutes[i]) {
            this.selectedProject.id = this.nonArhivedProjects[this.$route.params.id].id;
            this.item = this.nonArhivedProjects[this.$route.params.id];
            for (let k = 0; k < this.projectLeads.length; k++) {
              if (this.nonArhivedProjects[this.$route.params.id].project_lead_id == this.projectLeads[k].project_lead_id) {
                this.selectedProjectLead = this.projectLeads[k];
              }
            }
            return;
          }
        }
      }
    }
  },
  methods: {
    loadProjectOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const projects = this.projects_info.filter((p) => (searchQuery === '' && p.archived === 0) // When no search query then find only nonarchived
          || (searchQuery.length > 0 && (
            p.name.toLowerCase().includes(searchQuery.toLowerCase())
            || p.key.toLowerCase().includes(searchQuery.toLowerCase()))
          ));
        const leads = this.project_leads.filter((l) => l.id).map((l) => {
          return {
            id: `P${l.id}`,
            label: `${l.displayName}`,
            isDefaultExpanded: searchQuery.length > 0,
            children: projects.filter((p) => p.project_lead_id === l.id).map((p) => {
              return {
                id: p.id,
                label: `${p.name}`,
                archived: p.archived,
              };
            })
          };
        })
          .filter((l) => l.children.length > 0);

        callback(null, leads);
      }
    },

    projectSelected(projectId) {
      if (!projectId || !this.projects[projectId]) return;
      this.$router.push({ name: 'ProjectHome', params: { jira_key: this.projects[projectId].key } }).catch(() => { });
    },
    ...mapActions('JiraProjects', [
      'LOAD_JIRA_PROJECTS',
      'SEARCH_JIRA_NON_ARCHIVED_PROJECTS',
      'LOAD_PROJECT_LEADS']),
    ...mapMutations('JiraProjects', [
      'SET_PROJECT_SELECTED_LEAD'
    ]),
    ...mapActions('Auth', {
      logout: VT.LOGOUT,
    }),
    click() {
      // do nothing
    },
    getLabel(item) {
      if (item) {
        return item.name;
      }
      return '';
    },
    updateItems(text) {
      this.SEARCH_JIRA_NON_ARCHIVED_PROJECTS({ text: text, lead: this.selectedProjectLead.project_lead_id }).then((response) => {
        this.items = Object.values(JSON.parse(JSON.stringify(response.data.data))).sort((a, b) => { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
      }, (err) => {

      });
    },
    selectProjectLead(lead) {
      this.items = [];
      this.selectedProjectLead = lead;
      this.item = '';
      this.selectedProject.id = 0;
      // this.$router.push({name:'Home'});
      this.SET_PROJECT_SELECTED_LEAD(lead);
      this.SEARCH_JIRA_NON_ARCHIVED_PROJECTS({ text: '', lead: lead.project_lead_id }).then((response) => {
        this.items = Object.values(JSON.parse(JSON.stringify(response.data.data))).sort((a, b) => { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
      }, (err) => {

      });
    },
  },
  mounted() {
    this.LOAD_JIRA_PROJECTS();
    this.LOAD_PROJECT_LEADS();
  }
};
</script>

<style scoped lang=scss>
.disabled-treeselect-label-cust {
  color: $gray-800;
  cursor: not-allowed;
}

.softlocked-treeselect-label-cust {
  color: $gray-800;
}
</style>

<style lang="scss">
@import '~@riophae/vue-treeselect/dist/vue-treeselect.css';

.project-select {
  max-width: 250px;
  padding-left: 1em;

  .vue-treeselect,
  .vue-treeselect input {
    height: calc(1.5em + 0.5rem + 0px);
    font-size: 14px;
  }

  .vue-treeselect__value-container,
  .vue-treeselect__single-value {
    // line-height: 14px;
    font-size: 14px;
  }

  .vue-treeselect__control {
    height: calc(1.5em + 0.5rem);
    margin-top: -1px;
  }
}

.dropdown-toggle::after {
  /*display: none !important;*/
}

.projects-div {
  z-index: 1;
  margin-top: 10px;
}

.v-autocomplete {
  z-index: -1;
}

.v-autocomplete-input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #607d8b;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0;
}

.v-autocomplete-list {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0;
  background-color: #fff;
  /*border-top: none;*/
  max-height: 200px;
  overflow-y: auto;
  /*border-bottom: 1px solid #157977;*/
}

.v-autocomplete-list-item {
  cursor: pointer;
  /*padding: 5px;*/
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.v-autocomplete-list-item:hover {
  background-color: #e6e6e6;
}
</style>
